import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { FadeIn } from './FadeIn';
const FAQS = [{
  question: 'How many people can stay overnight?',
  answer: 'The retreat stay accommodates up to six guests.'
}, {
  question: 'Where can I book?',
  answer: 'You can book through Airbnb or Booking.com, or message Zev on WhatsApp if you have a question before booking.'
}, {
  question: 'Can I combine an overnight stay with a gathering?',
  answer: 'Yes. Use of the sauna, dome, pool and other facilities depends on your dates and the kind of gathering — message Zev and he will confirm.'
}, {
  question: 'Is there parking?',
  answer: 'Yes, parking is available on site, a short walk from the accommodation.'
}, {
  question: 'How far is it from Tel Aviv or Haifa?',
  answer: 'Kfar Pines is around 45 minutes from Tel Aviv, 35 minutes from Haifa and 8 minutes from Pardes Hanna.'
}];
export function StayFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-creamDeep px-6 py-20 md:px-12 md:py-28" data-id="element-535" data-mp="7ikvw4j624ok">
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-10 lg:grid-cols-[0.85fr_1.15fr] lg:gap-20" data-id="element-536" data-mp="2k9m1tsvfu6c">
        <div data-id="element-537" data-mp="h8w80ed07k6j">
          <FadeIn data-id="element-538" data-mp="h9fg73cuqu7d">
            <p className="mb-4 text-xs font-medium uppercase tracking-[0.2em] text-clay/70" data-id="element-539" data-mp="h9xlsqlemkry">
              Stay FAQ
            </p>
          </FadeIn>
          <FadeIn delay={0.1} data-id="element-540" data-mp="q7rfruvp52by">
            <h2 className="font-serif text-4xl leading-tight text-pine md:text-5xl" data-id="element-541" data-mp="q6y72od6g2r6">
              A few useful details before you arrive.
            </h2>
          </FadeIn>
        </div>

        <div className="border-t border-pine/15" data-id="element-542" data-mp="106gnwvxsj8f0">
          {FAQS.map((faq, index) => {
          const isOpen = index === openIndex;
          return <FadeIn key={faq.question} delay={index * 0.06} data-id="element-543" data-mp="31xtqhecad47w" data-mpi={index}>
                <div className="border-b border-pine/15" data-id="element-544" data-mp="3206h0fw40mwk">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} className="flex w-full items-center justify-between gap-5 py-5 text-left text-pine" aria-expanded={isOpen} data-id="element-545" data-mp="2x0k3s6ga76nr">
                    <span className="font-medium" data-id="element-546" data-mp="3vnaz4rcibnym">{faq.question}</span>
                    <ChevronDown className={`h-5 w-5 flex-none transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-547" data-mp="4iawefi6b2r0" />
                  </button>
                  {isOpen && <p className="max-w-2xl pb-5 font-light leading-relaxed text-clay" data-id="element-548" data-mp="dig3spnda156">
                      {faq.answer}
                    </p>}
                </div>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}